import React from "react";

const FeaturesSection = () => {
  const features = [
    {
      title: "Timely Payments and Credit Lines",
      description:
        "Every order is accompanied by advances and timely payments on deliveries and installations. 40 – 40 – 20 Payment cycle.",
      icon: "/assests/images/LandingPage/IP/wallet.svg",
    },
    {
      title: "No Onboarding fess or charges",
      description:
        "Pixell charges no onboarding fees or commissions from you. We negotiate contract manufacturing prices with you.",
      icon: "/assests/images/LandingPage/IP/polygon.svg",
    },
    {
      title: "Periodic Training & Ratings",
      description:
        "Introducing vendors to best industry practices and exposure to new technologies bringing quality to your executions.",
      icon: "/assests/images/LandingPage/IP/cart.svg",
    },
    {
      title: "Dedicated Account Manager",
      description:
        "You will be getting your very own Account Manager who will be helping you from addressing your queries to streamlining processes.",
      icon: "/assests/images/LandingPage/IP/dashboard.svg",
    },
    {
      title: "We provide – You Decide",
      description:
        "Pixell empowers vendors to decide if they want to accept the order or otherwise. The power lies in your hands.",
      icon: "/assests/images/LandingPage/IP/coins-hand.svg",
    },
    {
      title: "Dedicated Support Team",
      description:
        "Pixell offers 24x7 support, ensuring vendors and installation partners get prompt assistance for seamless operations.",

      icon: "/assests/images/LandingPage/IP/send.svg",
    },
  ];

  return (
    <div className="bg-white py-16 px-6 md:px-16">
      <div className="max-w-7xl mx-auto text-center">
        {/* Section Header */}
        <h3 className="text-sm uppercase tracking-widest text-gray-400">
          Packed with powerful features
        </h3>
        <h2 className="text-xl md:text-5xl font-bold mt-2">
          Unlock the Benefits of Partnering with Us
        </h2>
      </div>

      {/* Feature Grid */}
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {features.map((feature, index) => (
          <div
            key={index}
            className="flex flex-col items-start bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
          >
            {/* Icon */}
            <div className="text-3xl text-blue-600 rounded-lg">
              <img src={feature.icon} alt={feature.title} className="w-8 h-8" />
            </div>
            {/* Title */}
            <h4 className="text-lg font-semibold mt-4">{feature.title}</h4>
            {/* Description */}
            <p className="text-gray-600 mt-2">{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturesSection;
